export default __webpack_public_path__ + "static/media/Devanture_2.8bacc484.jpg";